// extracted by mini-css-extract-plugin
export default {"swiper":"SwiperUI_swiper__cUpbK","pb":"SwiperUI_pb__2Q6dU","dark":"SwiperUI_dark__lseDS","image":"SwiperUI_image__ooIhC","back":"SwiperUI_back__4KINM"};